import React from 'react';
import theme from '../theme/theme';
import { trunc } from '../utils';
import { Avatar, Grid, ListItem, useMediaQuery } from '@mui/material';

const RankedListItem = ({page, pagesize, p, i, user, isRankingScreen, totalPlayers}) => {

    const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

    return (
    <ListItem style={{
        backgroundColor: 
        /*Boolean(user) && user.uid === p.uid ?
            theme.palette.tertiary.main
        :*/
        
        (i % 2 === 0 || (i === "last" && pagesize % 2 === 0)) && isRankingScreen ?
            theme.palette.primary.contrastText :
        isRankingScreen ?
            theme.palette.grey[100] :        
        (i % 2 === 0 || (i === "last" && pagesize % 2 === 0)) ? 
            theme.palette.grey[50] :
            theme.palette.grey[200],
        color: theme.palette.grey[900],/*
        Boolean(user) && user.uid === p.uid ?
            theme.palette.primary.contrastText
            :theme.palette.grey[900],*/
        borderRadius: i === "first" ? '10px 10px 0px 0px' :
        /*((i + 1 ===  pagesize) ||
        (Boolean(leagues.filter((l) => l._id === league)[0] && 
        Boolean(leagues.filter((l) => l._id === league)[0].players) &&
        i + 1 === leagues.filter((l) => l._id === league)[0].players
            .sort((a,b) => (a.pts > b.pts) ? -1 : ((b.pts > a.pts) ? 1 : 0))
            .slice((page - 1) * pagesize, page * pagesize).length))) ? '0px 0px 10px 10px' :*/ ''}}>
        <Grid container direction="row" sx={{height: '35px', fontSize: '15px'}} alignItems={"center"}>
            <Grid item xs={1}>
                <span style={{fontWeight: '500', fontSize: isSmUp ? '15px' : '13px'}}>
                {i === "first" ? "1" :
                 i === "last" ? totalPlayers :
                (i + 1 + ((page - 1) * pagesize))}.
                </span>
            </Grid>
            <Grid item xs={1}>
                <Avatar src={p.photoURL} sx={{width: '25px', height: '25px'}} />
            </Grid>
            <Grid item xs={9} sx={{pl:1}}>
                <span style={Boolean(user) && user.uid === p.uid ? 
                    {backgroundColor: theme.palette.grey[800], color: theme.palette.primary.contrastText, 
                        borderRadius: '30px', marginLeft: isSmUp ? '-8px' : '2px', 
                        padding: isSmUp ? '5px 14px' : '4px 8px', 
                        fontSize: isSmUp ? '15px' : '13px', fontWeight: '500'} : 
                    { marginLeft: '7px', fontSize: isSmUp ? '15px' : '13px'}}>
                    <span style={{fontWeight: '800'}}>{trunc(Boolean(p) ? p.nickName : '', 20)}</span><span style={{fontSize: '12px', display: isSmUp || isRankingScreen ? 'inline-block' : 'none' }}>&nbsp;-&nbsp;{trunc(Boolean(p) ? p.displayName : '', isSmUp ? (25 - p.nickName.length) : (20  - p.nickName.length))}</span>
                </span>
            </Grid>
            <Grid item xs={1} sx={{fontSize: isSmUp ? '15px' : '13px'}}>
                {(Boolean(p.pts) && p.pts > 0 ) ? p.pts : 0}
            </Grid>
        </Grid>
    </ListItem>
    )

};
export default RankedListItem;